module.exports = __webpack_public_path__ + "static/img/slider3.ae7b4fe.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/slider3.jpeg
// module id = lVIc
// module chunks = 1